import { render, staticRenderFns } from "./add-booking.vue?vue&type=template&id=7815311a&scoped=true&"
import script from "./add-booking.vue?vue&type=script&lang=js&"
export * from "./add-booking.vue?vue&type=script&lang=js&"
import style0 from "./add-booking.vue?vue&type=style&index=0&id=7815311a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815311a",
  null
  
)

export default component.exports